import { useCallback, useMemo } from 'react';
import { AdaptiveMedia } from '#shared/components/AdaptiveImage';
import { VideoPlayer, type VideoPlayerInstance } from '#shared/components/VideoPlayer';
// eslint-disable-next-line @direct-frontend/modules/no-restricted-entity-imports -- типы поля медиа
import { MEDIA_TYPE_VIDEO, type MediaV2Field } from '#shared/lib/form';
import styles from './ProductDraggableGalleryMediaField.module.css';

export function ProductDraggableGalleryMediaFieldViewerItem({ media }: { media: MediaV2Field }) {
    const handleReady = useCallback((player: VideoPlayerInstance) => {
        player.setVideoStyle({ objectFit: 'contain' });
    }, []);

    const videoUrls = useMemo(
        () =>
            media.type === MEDIA_TYPE_VIDEO && media.stream_dash_url && media.stream_hls_url
                ? [media.stream_dash_url, media.stream_hls_url]
                : null,
        [media]
    );

    if (media.type === 'IMAGE') {
        return <AdaptiveMedia media={media} borderRadius="14" alt="Превью" width="100%" height="auto" fit="contain" />;
    }

    if (!videoUrls) {
        return null;
    }

    return <VideoPlayer videoUrls={videoUrls} muted className={styles.video} onReady={handleReady} />;
}
